import React from 'react';
import { User } from '@prisma/client';
const Info = ({ userData }: { userData: User }) => {
  return (
    <div>
      <h2>User Information</h2>
      <p>
        <strong>Name:</strong> {userData.firstName! + ' ' + userData.lastName! || 'N/A'}
      </p>
      <p>
        <strong>Email:</strong> {userData?.email || 'N/A'}
      </p>
      <p>
        <strong>Username:</strong> {userData?.subscriptionLevel || 'N/A'}
      </p>
    </div>
  );
};

export default Info;
